import './index.scss'

$('.header .myhamburger').on('click',function(){
  $('body').css({'height':'100vh','overflow-y':'hidden'})
  $('.menu-mask').css('z-index','1002').fadeIn()
  $('header .fixed-nav').addClass('active')
})
$('header .fixed-nav .close').on('click',function(){
  $('body').css({'height':'auto','overflow-y':'auto'})
  $('.menu-mask').fadeOut()
  $('header .fixed-nav').removeClass('active')
})

var mouseover_tid = [];
var mouseout_tid = [];
$(document).ready(function () {
  $(".header .nav .nav-item:nth-child(1)").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid[ index ] = setTimeout(function () {
          $(_self).addClass('hover');
          $('.menu-mask').css('z-index','997').fadeIn()
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid[ index ] = setTimeout(function () {
          $(_self).removeClass('hover');
          $('.menu-mask').fadeOut()
        }, 201);
      });
    });
});

let beforeScroH = $(document).scrollTop();
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  var contentH = $(document).height(); //内容高度

  if(scroH > 100){
    $('.header').addClass('scroll')
  }else{
    $('.header').removeClass('scroll')
  }

  // 显示返回按钮
  if(scroH > viewH){
    $('footer .backtop').addClass('show')
  }else{
    $('footer .backtop').removeClass('show')
  }
  // 页面滚动到底部固定返回按钮
  let backtopBtm = $('footer').outerHeight()
  if (contentH - (scroH + viewH) <= backtopBtm) { 
    $('footer .backtop').addClass('abs')
  }else{
    $('footer .backtop').removeClass('abs')
  }

  //判断页面是上滚还是下滚
  let delta = scroH - beforeScroH;
  if (delta > 0) {
    if(scroH > 50){
      $('.header').addClass('trans')
    }else{
      $('.header').removeClass('trans')
    }
  }
  if (delta < 0) {
    $('.header').removeClass('trans')
  }


  beforeScroH = scroH;
});